(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
		.state('frp-report', {
			parent: 'app',
			url: '/frp-report/{id}',
			data: {
				authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
				pageTitle: ''
			},
			views: {
				'content@': {
					templateUrl: 'app/frp-mde/frp-report/home/frp-report-home.html',
					controller: 'FRPReportHomeController',
					controllerAs: 'vm'
				}
			},
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                	$translatePartialLoader.addPart('frpReport');
                    $translatePartialLoader.addPart('frpmde');
                    return $translate.refresh();
                }],
                isPatientActivated: ['FrpReportService',  '$stateParams', '$state' , function (FrpReportService, $stateParams, $state) {
                    FrpReportService.isPatientActivated($stateParams.id).then(function() {});
                 }]
            }
		})
        .state('frp-report.ADMIN', {
            parent: 'frp-report',
            url: '/office',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/frp-report/admin/frp-report-admin.html',
                    controller: 'FRPReportAdminController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frpReport');
                    $translatePartialLoader.addPart('attendanceTracker');
                    return $translate.refresh();
                }],
                 supportedDataList: ['Auth', function(Auth) {
                    return Auth.getSupportedListRegister();
                 }],
                 userDetails: ['User', function (User) {
                    return User.getUserByCurrentLogin();
                 }],
                 qhpUsers: ['User', function (User) {
                      return User.getAllQHPUsers();
                  }],
                 staffUsers: ['User', function (User) {
                      return User.getAllStaffUsers();
                  }],
                 reportAdmin :['FrpReportService',  '$stateParams', function(FrpReportService, $stateParams){
                    return FrpReportService.getAdminReport($stateParams.id);
                 }],
                frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                    return FrpReportService.findById($stateParams.id);
                }],
                lectures: ['LectureService', function (LectureService) {
                    return LectureService.findAll();
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_REPORT_ADMIN);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('frp-report.ADMIN.VIEW', {
                parent: 'frp-report',
                url: '/office/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/admin/frp-report-admin.html',
                        controller: 'FRPReportAdminController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpReport');
                        $translatePartialLoader.addPart('attendanceTracker');
                        $translatePartialLoader.addPart('frpmde');
                        return $translate.refresh();
                    }],
                    supportedDataList: ['Auth', function(Auth) {
                        return Auth.getSupportedListRegister();
                    }],
                    userDetails: ['User', function (User) {
                        return User.getUserByCurrentLogin();
                    }],
                    qhpUsers: ['User', function (User) {
                        return User.getAllQHPUsers();
                    }],
                    staffUsers: ['User', function (User) {
                        return User.getAllStaffUsers();
                    }],
                    reportAdmin :['FrpReportService',  '$stateParams', function(FrpReportService, $stateParams){
                        return FrpReportService.getAdminReport($stateParams.id);
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    lectures: ['LectureService', function (LectureService) {
                        return LectureService.findAll();
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_REPORT_ADMIN);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
        .state('frp-report.MEDICAL', {
            parent: 'frp-report',
            url: '/medical',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/frp-report/ptp/frp-report-ptp.html',
                    controller: 'FRPReportPTPController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frpmde');
                    $translatePartialLoader.addPart('frpReport');
                    return $translate.refresh();
                }],
                frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                    return FrpReportService.findById($stateParams.id);
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.GENERAL);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('frp-report.MEDICAL.VIEW', {
                parent: 'frp-report',
                url: '/medical/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/ptp/frp-report-ptp.html',
                        controller: 'FRPReportPTPController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpmde');
                        $translatePartialLoader.addPart('frpReport');
                        return $translate.refresh();
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.GENERAL);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
        .state('frp-report.PT', {
            parent: 'frp-report',
            url: '/physical-functional',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/frp-report/pt/frp-report-pt.html',
                    controller: 'FRPReportPTController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frpReport');
                    $translatePartialLoader.addPart('mdeReport');
                    $translatePartialLoader.addPart('frpmde');
                    return $translate.refresh();
                }],
                frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                    return FrpReportService.findById($stateParams.id);
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_PT);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('frp-report.PT.VIEW', {
                parent: 'frp-report',
                url: '/physical-functional/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/pt/frp-report-pt.html',
                        controller: 'FRPReportPTController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpReport');
                        $translatePartialLoader.addPart('mdeReport');
                        $translatePartialLoader.addPart('frpmde');
                        return $translate.refresh();
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_PSYCH);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
        .state('frp-report.PSYCH', {
            parent: 'frp-report',
            url: '/psych',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/frp-report/psych/frp-report-psych.html',
                    controller: 'FRPReportPsychController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frpReport');
                    $translatePartialLoader.addPart('instrumentType');
                    $translatePartialLoader.addPart('frpmde');
                    return $translate.refresh();
                }],
                frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                    return FrpReportService.getFRPReportPsych($stateParams.id);
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_PSYCH);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('frp-report.PSYCH.VIEW', {
                parent: 'frp-report',
                url: '/psych/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/psych/frp-report-psych.html',
                        controller: 'FRPReportPsychController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpReport');
                        $translatePartialLoader.addPart('instrumentType');
                        $translatePartialLoader.addPart('frpmde');
                        return $translate.refresh();
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_PSYCH);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
        .state('frp-report.CONCLUSION', {
            parent: 'frp-report',
            url: '/conclusion',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/frp-mde/frp-report/conclusion/frp-report-conclusion.html',
                    controller: 'FRPReportConclusionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frpReport');
                    $translatePartialLoader.addPart('mdeReport');
                    $translatePartialLoader.addPart('frpmde');
                    $translatePartialLoader.addPart('goalStatus');

                    return $translate.refresh();
                }],
                frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                    return FrpReportService.findById($stateParams.id);
                }],
                templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                    return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_REPORT_CONCLUSION);
                }],
                isView: function () {
                    return false;
                }
            }
        })
            .state('frp-report.CONCLUSION.VIEW', {
                parent: 'frp-report',
                url: '/conclusion/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/conclusion/frp-report-conclusion.html',
                        controller: 'FRPReportConclusionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpReport');
                        $translatePartialLoader.addPart('mdeReport');
                        $translatePartialLoader.addPart('frpmde');
                        $translatePartialLoader.addPart('goalStatus');
                        return $translate.refresh();
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    templates: ['FRPMDETemplateService', 'ipmConstants', function(FRPMDETemplateService, constants) {
                        return FRPMDETemplateService.getAllTemplateByInputTypes(constants.FRP_MDE_TEMPLATE.FRP_REPORT_CONCLUSION);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
            .state('frp-report.ADDENDUM', {
                parent: 'frp-report',
                url: '/addendum',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/addendum/frp-report-addendum.html',
                        controller: 'FRPReportAddendumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpReport');
                        return $translate.refresh();
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    isView: function () {
                        return false;
                    }
                }
            })
            .state('frp-report.ADDENDUM.VIEW', {
                parent: 'frp-report',
                url: '/addendum/view',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_QHP', 'ROLE_ADMIN'],
                    pageTitle: ''
                },
                views: {
                    'content@': {
                        templateUrl: 'app/frp-mde/frp-report/addendum/frp-report-addendum.html',
                        controller: 'FRPReportAddendumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frpReport');
                        $translatePartialLoader.addPart('mdeReport');
                        $translatePartialLoader.addPart('frpmde');
                        $translatePartialLoader.addPart('goalStatus');
                        return $translate.refresh();
                    }],
                    frpReport: ['FrpReportService', '$stateParams', function (FrpReportService, $stateParams) {
                        return FrpReportService.findById($stateParams.id);
                    }],
                    isView: function () {
                        return true;
                    }
                }
            })
            .state('frp-report-preview', {
                parent: 'frp-report',
                url: '/preview',
                data: {
                    pageTitle: ''
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/frp-mde/pdf-report-preview-dialog/pdf-report-preview-dialog.html',
                        controller: 'PDFReportPreviewDiaglogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        windowClass: 'absolute-center',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                            frpReportId: function($stateParams) {
                                return $stateParams.id;
                            },
                            pdfData: function(FrpReportService) {
                                return FrpReportService.loadPdfReportPreviewData($stateParams.id);
                            }
                        }
                    }).result.then(function() {
                        // $state.go('patient-detail', {id:$stateParams.id}, {reload: true});
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
    }
})();
